// extracted by mini-css-extract-plugin
export default {"headerContainer":"SectionHeader_headerContainer__YoRs6","title":"SectionHeader_title__T18zH"};